var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-field-status"},[(_vm.item.status?.color)?_c('span',{staticClass:"__status-dots",style:({ backgroundColor: _vm.item.status.color })}):_vm._e(),_c('span',{staticStyle:{"color":"$mep-color-text-400"}},[_vm._v(_vm._s(_vm.item.status.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }